import React from "react";

interface SidebarProps {
  menu: React.ReactNode; // Accepts any menu component
  title?: string
}

const Sidebar: React.FC<SidebarProps> = ({ title='', menu }) => {
  return (
    <div className="d-flex flex-column flex-shrink-0 p-3 bg-light" style={{ minWidth: "250px", minHeight: "100vh" }}>
      <a
        href="/"
        className="d-flex align-items-center mb-3 mb-md-0 me-md-auto text-decoration-none text-dark"
      >
        <span className="fs-4">{title}</span>
      </a>
      <hr />
      <div>{menu}</div>
    </div>
  );
};

export default Sidebar;
